import { PbValues, PbResult } from './types';
import { ToolsTranslations } from '@/lib/translations/types';

export function calculatePb(values: PbValues, t?: ToolsTranslations['pb']): PbResult {
  const { marketPricePerShare, bookValuePerShare } = values;

  if (marketPricePerShare <= 0) {
    return { pbRatio: null, isValid: false, message: t?.invalid.marketPricePerShare ?? 'Marknadspris per aktie måste vara större än 0' };
  }
  if (bookValuePerShare <= 0) {
    return { pbRatio: null, isValid: false, message: t?.invalid.bookValuePerShare ?? 'Bokvärde per aktie måste vara större än 0' };
  }

  const pbRatio = Math.round((marketPricePerShare / bookValuePerShare) * 100) / 100; // PREC(...,2) - rounds to 2 decimal places
  
  if (!isFinite(pbRatio)) {
    return { pbRatio: null, isValid: false, message: t?.invalid.generic ?? 'Ogiltiga värden' };
  }
  
  return { pbRatio, isValid: true };
}
